import React, { useContext, useEffect } from 'react';
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useLoader } from "../../../../hooks/useLoader";
import { QueryStatus } from "../../../../types";
import { Alert, Grid } from "@mui/material";
import { OperacionCF } from "./types/types";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { SistemaTipo } from "../../../../types/enum/enum";
import SeccionCFDetalleTransaccion from './components/SeccionCFDetalleTransaccion';
import SeccionCFDatosOperacion from './components/SeccionCFDatosOperacion';
import { useOperacionCF } from './hooks/useOperacionCF';

interface SistemaCFContentProps {
  operacion: OperacionCF,
  codSistema: number,
}

const SistemaCFContent = ({ operacion, codSistema }: SistemaCFContentProps) => {
  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionCFDatosOperacion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionCFDetalleTransaccion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.CF}
            idOperacion={operacion.id}
          />
        </Grid>
      </Grid>
    </>
  )
}

function SistemaCF() {
  const { idOperacion, codSistema } = useContext<ContextOperacionType>(ContextOperacion)
  const { status, operacion } = useOperacionCF(idOperacion)
  const { showLoader, hideLoader } = useLoader()

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status])

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  if (!operacion) {
    return <></>
  }

  return (
    <SistemaCFContent
      operacion={operacion}
      codSistema={codSistema}
    />
  )
}

export default SistemaCF;